import React from "react";

import { AaaGameInformationConfigurationsDataType } from "../../../../models/forms";
import { LocalPlayerModes, OnlinePlayerModes } from "../../../../models/playerModes";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type AppInfoAaaConfigurationsProps = {
  dataInForm: AaaGameInformationConfigurationsDataType;
};

const AaaConfigurationsConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "localPlayerModes",
    {
      mapper: (
        data: AaaGameInformationConfigurationsDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.localPlayerModes
          .filter(value => value.selected)
          .map(element => {
            const localizedPlayerMode = localizedStrings.get(element.playerMode);
            if (element.playerMode === LocalPlayerModes.singleMultiplayer) {
              return localizedPlayerMode;
            }
            return `${localizedPlayerMode}: ${element.playersPerConsole} ${localizedStrings.get(
              "playersPerConsole"
            )}`;
          }),
    },
  ],
  [
    "onlinePlayerModes",
    {
      mapper: (
        data: AaaGameInformationConfigurationsDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.onlinePlayerModes
          .filter(value => value.selected)
          .map(element => {
            const localizedPlayerMode = localizedStrings.get(element.playerMode);
            if (element.playerMode === OnlinePlayerModes.onlineSinglePlayer) {
              return localizedPlayerMode;
            }
            return `${localizedPlayerMode}: ${element.playersPerConsole} ${localizedStrings.get(
              "playersPerConsole"
            )}`;
          }),
    },
  ],
  [
    "playersPerServer",
    {
      title: "aaaMassivelyMultiplayerCheckboxLabel",
      mapper: (
        data: AaaGameInformationConfigurationsDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.hasServerBasedGamePlay
          ? `${localizedStrings.get("aaaNumberOfPlayerPerServer")}: ${data.playersPerServer}`
          : "",
    },
  ],
  [
    "publisherHostedServices",
    {
      title: "aaaPublisherHostedServicesTitle",
    },
  ],
  [
    "extraPeripheralsDetails",
    {
      title: "aaaExtraPeripheralsOptionReadOnly",
    },
  ],
  [
    "requiredExtraPeripheralsDetails",
    {
      title: "aaaRequiredExtraPeripheralsOptionReadOnly",
    },
  ],
]);

export const ReadOnlyAaaConfigurations = ({ dataInForm }: AppInfoAaaConfigurationsProps) => {
  const extraStringsToLocalize = [
    "playerModes",
    "singleMultiplayer",
    "multiplayer",
    "couchCoOp",
    "onlineSinglePlayer",
    "onlineMultiplayer",
    "onlineCoOp",
    "aaaNumberOfPlayerPerServer",
    "playersPerConsole",
  ];
  return (
    <ReadOnlyForm
      formConfig={AaaConfigurationsConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
